// Store listings for the shop-owner app (bundle / package com.pettobook.app).
// Android is installed from Google Play only — the website no longer hands out
// an APK file.
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.pettobook.app";
